import { NotificationPanelContainer } from '../DaysRow.styles';
import { Stack, Badge, Typography } from '@mui/material';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import PropTypes from 'prop-types';

const NotificationPanel = ({ unassignedShiftsCount, hidden = true }) => {
  return (
    <NotificationPanelContainer>
      <Stack sx={{ display: hidden && 'none', padding: '0 2rem 0 6px' }} spacing={3} direction="row">
        <Badge badgeContent={unassignedShiftsCount} color="error">
          <NotificationsOutlinedIcon fontSize="medium" sx={{ color: '#0A84FF' }} />
        </Badge>
        <Typography variant="footNoteEmphasized">Need your attention</Typography>
      </Stack>
    </NotificationPanelContainer>
  );
};

NotificationPanel.propTypes = {
  unassignedShiftsCount: PropTypes.number,
  hidden: PropTypes.bool,
};

export default NotificationPanel;
